__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "root";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@internationalized/date", "3.12.4", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__("dd6671e3bd7c2016979b"))))));
			register("@tanstack/react-query", "5.101.4", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__("80d62b68cae7538b4281"))))));
			register("react-aria-components", "1.21.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(877)]).then(() => (() => (__webpack_require__("cb0744297bd8d9600fe7"))))));
			register("react-aria", "3.52.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(877)]).then(() => (() => (__webpack_require__("715ad142852cd72a3d49"))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__("63f14ac74ce296f77f4d"))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(8096), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__("5db0bf3481eaf9893ea3"))))));
			register("react", "18.3.1", () => (__webpack_require__.e(8096).then(() => (() => (__webpack_require__("8af190b70a6bc55c6f1b"))))));
			initExternal("e61c91c1a642c1d40654");
			initExternal("6cc197aa6e108cd65591");
			initExternal("c3b0e1041a830f12d086");
			initExternal("5fe034bbdb9a622b5973");
			initExternal("a1b285490c53ca621ea1");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};